<template>
  <div class="flex items-center gap-x-4">
    <div class="text-xs font-semibold uppercase">
      {{ t('pages.blog.shareText') }}
    </div>
    <div class="flex gap-x-4 text-primary-950">
      <a
        class="flex hover:text-secondary"
        :href="facebookLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TIcon
          :icon="['fab', 'square-facebook']"
          size="lg"
        />
      </a>
      <a
        class="flex hover:text-secondary"
        :href="twitterLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TIcon
          :icon="['fab', 'x-twitter']"
          size="lg"
        />
      </a>
      <a
        class="flex hover:text-secondary"
        :href="linkedinLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TIcon
          :icon="['fab', 'linkedin']"
          size="lg"
        />
      </a>
      <a
        class="flex hover:text-secondary"
        :href="pinterestLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TIcon
          :icon="['fab', 'pinterest']"
          size="lg"
        />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  shareText: string
}>()

const { t } = useI18n()
const route = useRoute()
const absoluteLocalePath = useAbsoluteLocalePath()

const shareUrl = computed(() => absoluteLocalePath(route.path))
const facebookLink = computed(() => encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl.value}`))
const twitterLink = computed(() =>
  encodeURI(`https://twitter.com/intent/tweet?url=${shareUrl.value}&text=${props.shareText}`),
)
const linkedinLink = computed(() => encodeURI(`https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl.value}`))
const pinterestLink = computed(() =>
  encodeURI(`https://pinterest.com/pin/create/button/?url=${shareUrl.value}&media=&description=${props.shareText}`),
)
</script>

<i18n src="~~/i18n/locales/common/pages/blog.json" lang="json" />
